import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DownloadModalPage } from './download-modal';
 
@NgModule({
  declarations: [
    DownloadModalPage,
  ],
  imports: [
    IonicPageModule.forChild(DownloadModalPage),
  ],
})
export class DownloadModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/download-modal/download-modal.module.ts